import { Axios, ToJson, UrlFactory } from "@gsx/common";
import {
    QuiltyResourceBody,
    QuiltyResourceListItem,
    QuiltyResourceListQuery,
    QuiltyResourceListResponse,
} from "@gsx/common/src/types/http/admin/quiltyResource";
import { adaptDate } from "../adapters";

const adaptRequest = (data: any): QuiltyResourceListItem => ({
    ...data,
    submissionDate: adaptDate(data.submissionDate),
});

export class QuiltyResource {
    private readonly urlFactory: UrlFactory;

    public constructor(private readonly axios: Axios, urlFactory: UrlFactory) {
        this.urlFactory = urlFactory.to("/admin/quiltyResources");
    }

    public async list(params: QuiltyResourceListQuery): Promise<QuiltyResourceListResponse> {
        const url = this.urlFactory.create("/");
        const response = await this.axios.get(url, { params });
        return {
            ...response.data,
            data: response.data.data.map(adaptRequest),
        };
    }

    public async create(
        body: Partial<ToJson<QuiltyResourceBody>>,
        formData: FormData,
    ): Promise<void> {
        const url = this.urlFactory.create(`/`);
        await this.axios
            .post(url, body)
            .then(async (res) => this.uploadMedia(res.data.id, formData));
    }

    public async update(
        id: string,
        body: Partial<ToJson<QuiltyResourceBody>>,
        formData: FormData,
    ): Promise<void> {
        const url = this.urlFactory.create(`/${id}`);
        await this.axios.put(url, body).then(async () => this.uploadMedia(id, formData));
    }

    public async get(id: string): Promise<QuiltyResourceBody> {
        const url = this.urlFactory.create(`/${id}`);
        const response = await this.axios.get(url);
        return response.data as QuiltyResourceBody;
    }

    public async delete(id: string): Promise<void> {
        const url = this.urlFactory.create(`/${id}`);
        await this.axios.delete(url);
    }

    public async sendEmail(quiltyResource: any) {
        const url = this.urlFactory.create(`/sendEmail`);
        await this.axios.post(url, quiltyResource);
    }

    private async uploadMedia(id: string, formData: FormData) {
        if (
            (formData.has("resource") && formData.get("resource") !== "null") ||
            (formData.has("picture") && formData.get("picture") !== "null")
        ) {
            const quiltyResourceMediaUrl = this.urlFactory.create(`/${id}/media`);

            await this.axios.put(quiltyResourceMediaUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        }
    }
}
